import React from 'react';
import cx from 'classnames';
import {texts} from './texts';
import styles from './UpdateStatus.module.scss';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import {observer} from 'mobx-react';
import {apiLocker, UpdateStatusTypes} from '../../../../../stores/Form/API_Locker';
import {changeLockerStatus} from '../../ScreenLocker/actions';

type Props = {
    session: string;
    componentClasses?: string;
    supportHtmlForm: boolean;
};

export const UpdateStatus = observer(({session, componentClasses, supportHtmlForm}: Props) => {
    const updateData = apiLocker.getDataBySession(session);
    // Only show if update exists, status is not none, AND it matches the expected form type
    const show =
        updateData &&
        updateData.status !== UpdateStatusTypes.none &&
        updateData.isHTMLForm === supportHtmlForm;
    const status = updateData?.status;
    if (!show) return null;

    if (status === UpdateStatusTypes.updating) {
        return (
            <div className={cx(styles.component, styles.updating, componentClasses)}>
                <div className={styles.spinner} />
                {texts.updating}
            </div>
        );
    } else if (status === UpdateStatusTypes.saved) {
        return (
            <div className={cx(styles.component, styles.success, componentClasses)}>
                <Icon componentClasses={styles.icon} icon={PriorityIcon.roundCheck} /> {texts.saved}
                <Icon
                    componentClasses={styles.close}
                    icon={PriorityIcon.closeBig}
                    iconColor="primary-700"
                    size="small"
                    onClick={() => changeLockerStatus(session, UpdateStatusTypes.none)}
                />
            </div>
        );
    }
    return null;
});
